/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/response_statuses": {
    /** Possible response statuses for meetings */
    get: operations["listResponseStatuses"];
  };
  "/conferences/{slug}/appearances/{appearanceId}/leads/stats": {
    /** Retrieve lead statistics for the specified appearance. */
    get: operations["getLeadStats"];
    parameters: {
      path: {
        appearanceId: string;
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/appearances/{appearanceId}/leads/{leadId}": {
    /** Add additional information about the specified lead. */
    patch: operations["updateLead"];
    parameters: {
      path: {
        appearanceId: string;
        leadId: string;
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/appearances/{appearanceId}/leads/export": {
    /** Export leads for the specified appearance as a CSV file. The file export is emailed as an attachment to the email associated with the authenticated user. */
    post: operations["exportLeads"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        appearanceId: string;
      };
    };
  };
  "/conferences/{slug}/appearances/{appearanceId}/leads": {
    /** List leads for the specified appearance. Only accepted leads are returned. */
    get: operations["listLeads"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        appearanceId: string;
      };
    };
  };
  "/conferences/{slug}": {
    /** Returns details about the specified conference. */
    get: operations["getConference"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences": {
    /** Lists all public conferences. Results are in an indeterminate order. */
    get: operations["listConferences"];
  };
  "/conferences/{slug}/investor_meetings": {
    /** Returns information about the current state of the authenticated investor in the investor-startup meetings flow. */
    get: operations["getInvestorMeetingInfo"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/investor_meetings/submit": {
    /** Submits the investor-startup meetings flow. Once submited no further amendments can be made to selections. Before the flow can be submitted a session must be selected and selections must be made. */
    post: operations["submitInvestorMeeting"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/investor_meetings/session": {
    /** Selects the specified session for the investor-startup meetings flow. The session can not be changed once selected. */
    post: operations["selectInvestorMeetingSession"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/investor_meetings/selections": {
    /** Adds the specified appearance to investor meeting selections. Selections may not be amended after the flow has been submitted. */
    post: operations["addInvestorMeetingSelection"];
    /** Removes the specified appearance from investor meeting selections. Selections may not be amended after the flow has been submitted. */
    delete: operations["removeInvestorMeetingSelection"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/startup_meetings": {
    /** Returns information about the authenticated startup attendees current state in the investor-startup meetings flow. */
    get: operations["getStartupMeetingInfo"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/startup_meetings/{sessionId}/accept": {
    /** Accepts a investor-startup meetings session with the specified session timeslot. GDPR agreement must be accepted before interacting with this endpoint. */
    post: operations["acceptStartupMeetingSession"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        sessionId: string;
      };
    };
  };
  "/conferences/{slug}/startup_meetings/{sessionId}/reject": {
    /** Rejects a investor-startup meetings session. */
    post: operations["rejectStartupMeetingSession"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        sessionId: string;
      };
    };
  };
  "/conferences/{slug}/startup_meetings/{sessionId}/introduce": {
    /** Request an email introduction for an investor-startup meetings session. Instead of meeting with the investor we introduce them by email before the conference. */
    post: operations["introduceStartupMeetingSession"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        sessionId: string;
      };
    };
  };
  "/conferences/{slug}/startup_meetings/gdpr": {
    /** Accepts the startups GDPR agreement for the investor-startup meetings flow. GDPR agreement must be accepted before interacting with investor-startup meeting sessions. */
    post: operations["acceptStartupMeetingGdpr"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/countries": {
    /** Returns the list of countries available for a conference. Attendees may select a country for their public profile. */
    get: operations["listCountries"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/conference_topics": {
    /** Returns the list of topics available for a conference. */
    get: operations["listTopics"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/conference_industries": {
    /** Returns the list of industries available for a conference. */
    get: operations["listIndustries"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/me/visa_letter_requests": {
    /**
     * Returns visa letter request information for the authenticated attendee. Calling this endpoint without first requesting a visa letter will result in a not found response.
     *
     * Once a letter has been requested the `pdf` attribute will be null until the document has been generated. Once the document has been generated `pdf` will be a URL to download the document. Clients may poll this endpoint until it is available.
     */
    get: operations["getVisaLetterRequest"];
    /**
     * Requests a visa letter document for the authentiated attendee. It can be used to aid in aquiring a visa to the conference country.
     *
     * Only one letter can be requested per attendee. Further calls will result in a conflict response.
     */
    post: operations["requestVisaLetter"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/me/registration_certificate_letters": {
    /**
     * Returns registration letter request information for the authenticated attendee. Calling this endpoint without first requesting a registration letter will result in a not found response.
     *
     * Once a letter has been requested the `pdf` attribute will be null until the document has been generated. Once the document has been generated `pdf` will be a URL to download the document. Clients may poll this endpoint until it is available.
     */
    get: operations["getRegistrationCertificateLetterRequest"];
    /**
     * Requests a registration certificate letter document for the authentiated attendee. It can be used to prove you physically attended the conference.
     *
     * The attendee must have physically attended the conference in order to be eligible for a registration certificate letter. Otherwise this endpoint returns an unprocessable entity response.
     *
     * Only one letter can be requested per attendee. Further calls will result in a conflict response.
     */
    post: operations["requestRegistrationCertificateLetter"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/me": {
    /** This endpoint returns information about the current authenticated attendee. */
    get: operations["getUser"];
    /** Updates the profile of the currently authenticated attendee. */
    put: operations["updateProfile"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/algolia": {
    /** This endpoint returns algolia credentials and common indices for the specified conference. */
    get: operations["getAlgoliaSettings"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/appearances/{id}": {
    /** This endpoint returns details about an appearance. */
    get: operations["getAppearance"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        id: string;
      };
    };
  };
  "/conferences/{slug}/me/avatar": {
    /** Uploads and updates the avatar of the currently authenticated attendee. */
    get: operations["uploadAvatar"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/me/people/verify_phone_number": {
    /**
     * Starts the phone number verification flow for the authenticated attendee. A verification code will be sent to the provided phone number, and should be submitted to the `verify_pin_code` endpoint to complete the verification.
     *
     * If we were unable to send a verification code to the provided phone number the response will be 422.
     */
    put: operations["startPhonerNumberVerification"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/me/people/verify_pin_code": {
    /**
     * Completes phone number verification by confirming the verification code received in the `verify_phone_number` endpoint.
     *
     * If verification fails the response will be 404.
     */
    put: operations["completePhoneNumberVerification"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/schedule_timeslots": {
    /** This endpoint returns a list of all public timeslots on the schedule. When authenticated as admin, non-public timeslots are also returned. */
    get: operations["listTimeslots"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/schedule_timeslots/live_now": {
    /** This endpoint returns a list of all public timeslots on the schedule that are currently ongoing. When authenticated as admin, non-public timeslots are also returned. */
    get: operations["liveNow"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/otp_challenges": {
    /**
     * This endpoint creates a new OTP challenge for the one-time code login flow. On success the server responds with a nonce and sends a one-time code to the attendee's email address. The client may verify an OTP challenge using the nonce + code.
     *
     * A challenge may only be verified once and expires after a short time.
     */
    post: operations["createOtpChallenge"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/otp_challenges/{id}/verify": {
    /**
     * This endpoint verifies a challenge issued by the createOtpChallenge endpoint. On success a JWT token is returned that can be used to authenticate as an attendee.
     *
     * This endpoint is rate limited after a certain number of failed attempts.
     */
    post: operations["verifyOtpChallenge"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        /** Nonce of the challenge to verify */
        id: string;
      };
    };
  };
  "/conferences/{slug}/me/chat_token": {
    /** Creates and returns credentials required to connect to chat. When called on mobile the device will be recorded as an active device for the attendee. */
    post: operations["configureChat"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
  };
  "/conferences/{slug}/attendances/{id}": {
    /** This endpoint retrieves a single attendee by ID. */
    get: operations["getAttendee"];
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        /** Attendee ID */
        id: string;
      };
    };
  };
}

export interface components {
  schemas: {
    /**
     * ResponseStatus
     * @description Types of response statuses for meetings.
     */
    ResponseStatus: {
      id: string;
      label: string;
      color_hex: string;
      icon: string;
    };
    /**
     * Lead
     * @description A lead that has been collected on behalf of an appearance.
     */
    Lead: {
      id: string;
      /** @enum {string} */
      status: "pending" | "accepted" | "rejected";
      source?: string;
      notes?: string;
      /** Format: date-time */
      created_at: string;
      author?: components["schemas"]["LeadAuthor"];
      subject: components["schemas"]["LeadSubject"];
    };
    /**
     * LeadStats
     * @description Aggregated lead stats for an appearance.
     */
    LeadStats: {
      total_leads: number;
      total_accepted_leads: number;
      my_leads: number;
      my_accepted_leads: number;
    };
    /**
     * LeadAuthor
     * @description The attendee who authored a lead.
     */
    LeadAuthor: {
      /** Format: uuid */
      id: string;
      name: string;
      /** Format: uri */
      avatar_url?: string;
    };
    /**
     * LeadSubject
     * @description The attendee who is the subject of a lead.
     */
    LeadSubject: {
      id: string;
      name: string;
      /** Format: uri */
      avatar_url?: string;
      company_name?: string;
      job_title?: string;
    };
    /** @description Information about a conference. */
    Conference: {
      /** Format: uuid */
      id: string;
      slug: string;
      name: string;
      /** Format: hostname */
      domain: string | null;
      /** Format: hostname */
      webapp_domain: string | null;
      /** Format: hostname */
      public_website_domain: string | null;
      prioritised_domain: boolean;
      /** Format: date */
      start_date: string | null;
      /** Format: date */
      end_date: string | null;
      timezone: string | null;
      /** Format: hostname */
      branch_slug: string | null;
      primary_colour: string | null;
      secondary_colour: string | null;
      tertiary_colour: string | null;
      /** Format: uri */
      logo_landscape_url: string | null;
      /** Format: uri */
      favicon_url: string | null;
      /** Format: uri */
      background_image_url: string | null;
    };
    /**
     * InvestorMeetingInfo
     * @description The current state of the authenticated investor in the investor-startup meetings flow.
     */
    InvestorMeetingInfo: {
      /** Format: uri */
      logo_url?: string;
      session_duration_minutes: number;
      meetings_per_session: number;
      minimum_selections: number;
      /** Format: date-time */
      submission_opens_at?: string;
      /** Format: date-time */
      submission_closes_at?: string;
      submission_opened: boolean;
      submission_closed: boolean;
      gdpr_agreement: string;
      submission: components["schemas"]["InvestorMeetingSubmission"];
      sessions: components["schemas"]["InvestorMeetingSession"][];
    };
    /**
     * InvestorMeetingSession
     * @description A session that may be claimed by an investor for investor-startup meetings.
     */
    InvestorMeetingSession: {
      /** Format: uuid */
      id: string;
      name: string;
      /** Format: date-time */
      starts_at: string;
      /** Format: date-time */
      ends_at: string;
      available: boolean;
    };
    /**
     * InvestorMeetingSelection
     * @description A startup selected for a meeting by an investor in investor-startup meetings flow.
     */
    InvestorMeetingSelection: {
      /** Format: uuid */
      id: string;
      name: string;
      /** Format: uri */
      logo_url: string;
      industry: string;
    };
    /**
     * InvestorMeetingSubmission
     * @description The submission state of an investor in the investor-startup meetings flow.
     */
    InvestorMeetingSubmission: {
      submitted: boolean;
      selected_session?: components["schemas"]["InvestorMeetingSession"];
      selected_appearances: components["schemas"]["InvestorMeetingSelection"][];
    };
    /** @description Describes the current state for a startup attendee in the investor-startup meetings flow. */
    StartupMeetingInfo: {
      /** Format: uri */
      logo_url?: string;
      /** Format: date-time */
      submission_opens_at?: string;
      /** Format: date-time */
      submission_closes_at?: string;
      submission_open: boolean;
      gdpr_agreement: string;
      gdpr_accepted: boolean;
      sessions: components["schemas"]["StartupMeetingSession"][];
    };
    /** @description A single timeslot in an investor-startup meeting session. */
    StartupMeetingSessionTimeslot: {
      /** Format: uuid */
      id: string;
      name: string;
      /** Format: date-time */
      starts_at: string;
      /** Format: date-time */
      ends_at: string;
      available: boolean;
    };
    /** @description The investor attendee that selected a startup for an investor-startup meeting session. */
    StartupMeetingSessionInvestor: {
      /** Format: uuid */
      id: string;
      name: string;
      /** Format: uri */
      avatar_url?: string;
      company_name?: string;
      public_role?: string;
    };
    /** @description An investor-startup meetings session a startup has been selected for. */
    StartupMeetingSession: {
      /** Format: uuid */
      id: string;
      name: string;
      /** Format: date-time */
      starts_at: string;
      /** Format: date-time */
      ends_at: string;
      /** @enum {string} */
      status: "pending" | "accepted" | "rejected" | "introduce" | "submitted";
      selected_session_timeslot?: components["schemas"]["StartupMeetingSessionTimeslot"];
      session_timeslots: components["schemas"]["StartupMeetingSessionTimeslot"][];
      investor: components["schemas"]["StartupMeetingSessionInvestor"];
    };
    Country: {
      id: string;
      name: string;
      alpha2_code: string;
      calling_code: number;
      pos: number;
    };
    /** @description A request to generate a visa letter for an attendee. */
    VisaLetterRequest: {
      /** Format: uuid */
      id: string;
      /** Format: date-time */
      created_at: string;
      /** Format: date-time */
      updated_at: string;
      /** Format: uuid */
      attendance_id: string;
      /** Format: uuid */
      conference_nationality_id: string;
      /** Format: uuid */
      conference_residency_id: string;
      name: string;
      /** Format: email */
      email: string;
      passport_number: string;
      /** Format: date */
      date_of_birth: string;
      booking_ref: string;
      /** Format: uri */
      pdf?: string;
    };
    /**
     * RegistrationLetterRequest
     * @description A request to generate a registration letter for an attendee.
     */
    RegistrationLetterRequest: {
      id: string;
      /** Format: date-time */
      created_at: string;
      /** Format: date-time */
      updated_at: string;
      /** Format: uuid */
      attendance_id: string;
      /** Format: uuid */
      ticket_id: string;
      /** Format: uri */
      pdf?: string;
    };
    /** @description Information about the current authenticated attendee. */
    Me: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      person_id: string;
      qr_code: string;
      oref: number;
      /** Format: uuid */
      public_role_id: string;
      /** Format: date-time */
      deleted_at?: string;
      /** Format: date-time */
      checked_in_at?: string;
      /** Format: uuid */
      conference_industry_id?: string;
      conference_topic_ids: string[];
      seeking_topic_ids: string[];
      offering_topic_ids: string[];
      onboarded: boolean;
      /** Format: uuid */
      appearance_id?: string;
      vip: boolean;
      investor: boolean;
      operational_add_ons: {
        /** Format: uuid */
        id: string;
        name: string;
        mime_type: string;
        data?: { [key: string]: unknown };
      }[];
      ticket: {
        /** Format: uuid */
        id: string;
        /** Format: email */
        email: string;
        booking_ref: string;
        name: string;
        public_role: string;
        registration_area: string;
        registration_area_color?: string;
        accreditation: string;
        accreditation_color?: string;
        add_ons: {
          id: string;
          name: string;
          mime_type: string;
          data?: { [key: string]: unknown };
        }[];
      };
      person: {
        /** Format: uuid */
        id: string;
        bio?: string;
        pronoun?: string;
        name: string;
        first_name: string;
        last_name?: string;
        /** Format: uuid */
        country_id?: string;
        city?: string;
        phone_number?: string;
        phone_number_verified: boolean;
        /** Format: uri */
        avatar_url: string;
        avatar_urls: {
          /** Format: uri */
          tiny?: string;
          /** Format: uri */
          thumb?: string;
          /** Format: uri */
          medium?: string;
          /** Format: uri */
          large?: string;
          /** Format: uri */
          original?: string;
        };
        job_title?: string;
        company_name?: string;
        /** Format: uuid */
        industry_id?: string;
        /** Format: date-time */
        contacts_uploaded_at?: string;
        social_authentications: {
          /** Format: uuid */
          id: string;
          /** @enum {string} */
          provider: "twitter" | "facebook" | "github";
          username: string;
          display_name?: string;
          /** Format: uri */
          url?: string;
        }[];
      };
      features: {
        focus_mode: boolean;
        partner_leads: boolean;
      };
    };
    /**
     * AlgoliaSettings
     * @description Algolia credentials and common indices for a conference.
     */
    AlgoliaSettings: {
      key: string;
      app_id: string;
      indexes: {
        attendances: string;
        appearances: string;
        schedule_timeslot: string;
      };
    };
    /**
     * Appearance
     * @description A company appearing at a conference.
     */
    Appearance: {
      /** Format: uuid */
      id: string;
      /** Format: date-time */
      deleted_at?: string;
      stand_number_info?: string;
      oref: number;
      /** Format: uuid */
      conference_industry_id: string;
      attendance_ids: string[];
      hidden: boolean;
      /** Format: uuid */
      track_type_id: string;
      /** Format: uuid */
      track_id: string;
      pitch_video: {
        /** Format: uri */
        vimeo_url?: string;
      };
      /** Format: uri */
      video_file_url?: string;
      partner_rooms_enabled: boolean;
      endorsed_appearance_ids: string[];
      /** Format: uuid */
      endorser_appearance_id?: string;
      /** Format: uri */
      booth_url?: string;
      venue?: string;
      /** Format: date */
      exhibition_date?: string;
      /** Format: uri */
      pitch_deck_url?: string;
      attendances: {
        /** Format: uuid */
        id: string;
        first_name: string;
        last_name?: string;
        company_name?: string;
        job_title?: string;
        /** Format: uri */
        avatar_url?: string;
        avatar_urls: { [key: string]: unknown };
        seeking_topic_ids: string[];
        offering_topic_ids: string[];
      }[];
      company: {
        /** Format: uuid */
        id: string;
        name: string;
        elevator_pitch?: string;
        /** Format: uuid */
        industry_id?: string;
        /** Format: uri */
        logo_url?: string;
        external_urls: { [key: string]: unknown };
        /** Format: uuid */
        country_id?: string;
        city?: string;
      };
      attendance_appearances: {
        /** Format: uuid */
        id: string;
        /** Format: uuid */
        attendance_id: string;
        /** Format: uuid */
        appearance_id: string;
        featured: boolean;
        /** Format: date-time */
        created_at: string;
        /** Format: date-time */
        updated_at: string;
      }[];
      conference_industries: { [key: string]: unknown }[];
      appearance_products: { [key: string]: unknown }[];
    };
    /** UploadedAvatar */
    UploadedAvatar: {
      person: {
        /** Format: uri */
        avatar_url: string;
      };
    };
    /**
     * Topic
     * @description A topic for attendee interests. Unique per-conference.
     */
    Topic: {
      /** Format: uuid */
      id: string;
      /** @description The underlying topic. Unique across conferences. */
      topic: {
        /** Format: uuid */
        id: string;
        name: string;
      };
    };
    /**
     * Industry
     * @description An industry for attendees. Unique per-conference.
     */
    Industry: {
      /** Format: uuid */
      id: string;
      /** @description The underlying industry. Unique across conferences. */
      industry: {
        /** Format: uuid */
        id: string;
        name: string;
      };
    };
    /** @description A timeslot on the conference schedule */
    Timeslot: {
      /** Format: uuid */
      id: string;
      slug?: string;
      title?: string;
      description?: string;
      /** Format: date-time */
      starts_at: string;
      /** Format: date-time */
      ends_at: string;
      visible: boolean;
      conference_topic_ids?: string[];
      /** Format: uuid */
      schedule_track_id?: string;
      schedule_track_ids: string[];
      /** Format: uuid */
      location_id: string;
      facebook_url?: unknown | null;
      youtube_url?: unknown | null;
      vimeo_url?: unknown | null;
      /** Format: uri */
      static_video_url?: string;
      /** Format: uri */
      livestream_url?: string;
      online_session: boolean;
      premium: boolean;
      archivable: boolean;
      /** Format: uri */
      gatepass_url?: string;
      broadcast_channel_id?: unknown | null;
      /** Format: uuid */
      calendar_event_id: string;
      /** Format: uuid */
      appearance_id?: string;
      /** Format: uuid */
      calendar_event_format_id: string;
      timeslot_participations?: {
        /** Format: uuid */
        id: string;
        /** Format: uuid */
        attendance_id: string;
        /** Format: date-time */
        created_at: string;
      }[];
    };
    /**
     * Timeslot V2
     * @description A timeslot on the conference schedule. The v2 timeslot includs denormalized information about related entities.
     */
    TimeslotV2: {
      /** Format: uuid */
      id: string;
      slug: string;
      title: string;
      description?: string;
      /** Format: date-time */
      starts_at: string;
      /** Format: date-time */
      ends_at: string;
      visible: boolean;
      conference_topic_ids: string[];
      /** Format: uuid */
      schedule_track_id?: string;
      schedule_track_ids: string[];
      /** Format: uuid */
      location_id: string;
      facebook_url?: unknown | null;
      youtube_url?: unknown | null;
      vimeo_url?: unknown | null;
      /** Format: uri */
      static_video_url?: string;
      /** Format: uri */
      livestream_url?: string;
      online_session: boolean;
      premium: boolean;
      archivable: boolean;
      /** Format: uri */
      gatepass_url?: string;
      broadcast_channel_id?: unknown | null;
      /** Format: uuid */
      calendar_event_id: string;
      /** Format: uuid */
      appearance_id?: string;
      /** Format: uuid */
      calendar_event_format_id: string;
      timeslot_participations: {
        /** Format: uuid */
        id: string;
        /** Format: uuid */
        attendance_id: string;
        /** Format: date-time */
        created_at: string;
      }[];
      topics: {
        id?: string;
        name?: string;
      }[];
      schedule_track: {
        /** Format: uuid */
        id: string;
        name: string;
      };
      curated_tracks: {
        id?: string;
        name?: string;
      }[];
      location: {
        /** Format: uuid */
        id: string;
        name: string;
      };
      sponsor?: {
        /** Format: uuid */
        id: string;
        name: string;
        /** Format: uri */
        logo_url?: string;
      };
      participants: {
        id?: string;
        name?: string;
        company_name?: string;
        job_title?: string;
        avatar_url?: string;
      }[];
    };
    /**
     * OtpChallenge
     * @description An issued one-time code login challenge.
     */
    OtpChallenge: {
      /**
       * Format: uuid
       * @description Uniquely identifies the challenge.
       */
      id: string;
      /**
       * @description Code length hint for clients.
       * @example 6
       */
      code_length: number;
      /**
       * Format: date-time
       * @description Time the challenge expires.
       */
      expires_at: string;
    };
    /**
     * OtpChallengeResponse
     * @description The response to a successful OTP challenge.
     */
    OtpChallengeResponse: {
      auth_token: string;
    };
    /**
     * ChatSettings
     * @description Holds settings required to connect to chat.
     */
    ChatSettings: {
      /** @description The PubNub auth key. */
      chat_token: string;
      /** @description The PubNub channel groups consolidate messages will be sent over. */
      channel_groups: string;
      /** @description The attendee's public chat identifier. */
      identity: string;
      /** @description The public PubNub publish key. */
      publish_key: string;
      /** @description The public PubNub subcribe key. */
      subscrike_key: string;
    };
    /** Attendee */
    Attendee: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      public_role_id: string;
      oref: number;
      conference_topic_ids: string[];
      seeking_topic_ids: string[];
      offering_topic_ids: string[];
      /** Format: email */
      email?: string;
      person: {
        /** Format: uuid */
        id: string;
        first_name: string;
        last_name?: string;
        job_title?: string;
        bio?: string;
        company_name?: string;
        /** Format: uuid */
        country_id?: string;
        /** Format: uri */
        avatar_url?: string;
      };
    };
  };
  responses: {
    /** Generic error response with a list of errors. */
    Error: {
      content: {
        "application/json": {
          errors: {
            status: number;
            title: string;
            detail?: string;
          }[];
        };
      };
    };
  };
  parameters: {
    /** @description Unique human-friendly conference specifier */
    Slug: string;
  };
  requestBodies: {};
}

export interface operations {
  /** Possible response statuses for meetings */
  listResponseStatuses: {
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["ResponseStatus"][];
          };
        };
      };
    };
  };
  /** Retrieve lead statistics for the specified appearance. */
  getLeadStats: {
    parameters: {
      path: {
        appearanceId: string;
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["LeadStats"];
          };
        };
      };
      403: components["responses"]["Error"];
    };
  };
  /** Add additional information about the specified lead. */
  updateLead: {
    parameters: {
      path: {
        appearanceId: string;
        leadId: string;
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Lead"];
          };
        };
      };
      403: components["responses"]["Error"];
    };
    requestBody: {
      content: {
        "application/json": {
          notes?: string;
        };
      };
    };
  };
  /** Export leads for the specified appearance as a CSV file. The file export is emailed as an attachment to the email associated with the authenticated user. */
  exportLeads: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        appearanceId: string;
      };
    };
    responses: {
      /** No Content */
      204: never;
      403: components["responses"]["Error"];
    };
  };
  /** List leads for the specified appearance. Only accepted leads are returned. */
  listLeads: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        appearanceId: string;
      };
      query: {
        /** Return elements in the list at the specified page */
        page?: number;
        /** Return up to the specified number of elements per page */
        per_page?: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Lead"][];
          };
        };
      };
    };
  };
  /** Returns details about the specified conference. */
  getConference: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Conference"];
          };
        };
      };
      /** Not Found */
      404: unknown;
    };
  };
  /** Lists all public conferences. Results are in an indeterminate order. */
  listConferences: {
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Conference"][];
          };
        };
      };
    };
  };
  /** Returns information about the current state of the authenticated investor in the investor-startup meetings flow. */
  getInvestorMeetingInfo: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["InvestorMeetingInfo"];
          };
        };
      };
    };
  };
  /** Submits the investor-startup meetings flow. Once submited no further amendments can be made to selections. Before the flow can be submitted a session must be selected and selections must be made. */
  submitInvestorMeeting: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** No Content */
      204: never;
    };
    requestBody: {
      content: {
        "application/json": {
          accept_gdpr: boolean;
        };
      };
    };
  };
  /** Selects the specified session for the investor-startup meetings flow. The session can not be changed once selected. */
  selectInvestorMeetingSession: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** No Content */
      204: never;
    };
    requestBody: {
      content: {
        "application/json": {
          /** Format: uuid */
          session_id: string;
        };
      };
    };
  };
  /** Adds the specified appearance to investor meeting selections. Selections may not be amended after the flow has been submitted. */
  addInvestorMeetingSelection: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** No Content */
      204: never;
    };
    requestBody: {
      content: {
        "application/json": {
          /** Format: uuid */
          appearance_id: string;
        };
      };
    };
  };
  /** Removes the specified appearance from investor meeting selections. Selections may not be amended after the flow has been submitted. */
  removeInvestorMeetingSelection: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** No Content */
      204: never;
    };
    requestBody: {
      content: {
        "application/json": {
          /** Format: uuid */
          appearance_id: string;
        };
      };
    };
  };
  /** Returns information about the authenticated startup attendees current state in the investor-startup meetings flow. */
  getStartupMeetingInfo: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["StartupMeetingInfo"];
          };
        };
      };
    };
  };
  /** Accepts a investor-startup meetings session with the specified session timeslot. GDPR agreement must be accepted before interacting with this endpoint. */
  acceptStartupMeetingSession: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        sessionId: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["StartupMeetingSession"];
          };
        };
      };
    };
    requestBody: {
      content: {
        "application/json": {
          /** Format: uuid */
          session_timeslot_id: string;
        };
      };
    };
  };
  /** Rejects a investor-startup meetings session. */
  rejectStartupMeetingSession: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        sessionId: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["StartupMeetingSession"];
          };
        };
      };
    };
  };
  /** Request an email introduction for an investor-startup meetings session. Instead of meeting with the investor we introduce them by email before the conference. */
  introduceStartupMeetingSession: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        sessionId: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["StartupMeetingSession"];
          };
        };
      };
    };
  };
  /** Accepts the startups GDPR agreement for the investor-startup meetings flow. GDPR agreement must be accepted before interacting with investor-startup meeting sessions. */
  acceptStartupMeetingGdpr: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** No Content */
      204: never;
    };
    requestBody: {
      content: {
        "application/json": {
          accept_gdpr: boolean;
        };
      };
    };
  };
  /** Returns the list of countries available for a conference. Attendees may select a country for their public profile. */
  listCountries: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Country"][];
          };
        };
      };
    };
  };
  /** Returns the list of topics available for a conference. */
  listTopics: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Topic"][];
          };
        };
      };
    };
  };
  /** Returns the list of industries available for a conference. */
  listIndustries: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Industry"][];
          };
        };
      };
    };
  };
  /**
   * Returns visa letter request information for the authenticated attendee. Calling this endpoint without first requesting a visa letter will result in a not found response.
   *
   * Once a letter has been requested the `pdf` attribute will be null until the document has been generated. Once the document has been generated `pdf` will be a URL to download the document. Clients may poll this endpoint until it is available.
   */
  getVisaLetterRequest: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["VisaLetterRequest"];
          };
        };
      };
      /** Not Found */
      404: unknown;
    };
  };
  /**
   * Requests a visa letter document for the authentiated attendee. It can be used to aid in aquiring a visa to the conference country.
   *
   * Only one letter can be requested per attendee. Further calls will result in a conflict response.
   */
  requestVisaLetter: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** Created */
      201: {
        content: {
          "application/json": {
            data: components["schemas"]["VisaLetterRequest"];
          };
        };
      };
      /** Conflict */
      409: unknown;
    };
    requestBody: {
      content: {
        "application/json": {
          /** @description Name to be printed on the document. May be different from attendee profile name. Should match name on passport. */
          name: string;
          /**
           * Format: uuid
           * @description Nationality country ID
           */
          nationality_id: string;
          /**
           * Format: uuid
           * @description Residency country ID
           */
          residency_id: string;
          passport_number: string;
          /** Format: date */
          date_of_birth: string;
        };
      };
    };
  };
  /**
   * Returns registration letter request information for the authenticated attendee. Calling this endpoint without first requesting a registration letter will result in a not found response.
   *
   * Once a letter has been requested the `pdf` attribute will be null until the document has been generated. Once the document has been generated `pdf` will be a URL to download the document. Clients may poll this endpoint until it is available.
   */
  getRegistrationCertificateLetterRequest: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["RegistrationLetterRequest"];
          };
        };
      };
      /** Not Found */
      404: unknown;
    };
  };
  /**
   * Requests a registration certificate letter document for the authentiated attendee. It can be used to prove you physically attended the conference.
   *
   * The attendee must have physically attended the conference in order to be eligible for a registration certificate letter. Otherwise this endpoint returns an unprocessable entity response.
   *
   * Only one letter can be requested per attendee. Further calls will result in a conflict response.
   */
  requestRegistrationCertificateLetter: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** Created */
      201: {
        content: {
          "application/json": {
            data: components["schemas"]["RegistrationLetterRequest"];
          };
        };
      };
      /** Conflict */
      409: unknown;
      /** Unprocessable Entity */
      422: unknown;
    };
  };
  /** This endpoint returns information about the current authenticated attendee. */
  getUser: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Me"];
          };
        };
      };
    };
  };
  /** Updates the profile of the currently authenticated attendee. */
  updateProfile: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Me"];
          };
        };
      };
    };
    requestBody: {
      content: {
        "application/json": {
          seeking_topic_ids?: string[];
          offering_topic_ids?: string[];
          /** Format: uuid */
          conference_industry_id?: string;
          person?: {
            first_name?: string;
            last_name?: string;
            bio?: string;
            pronoun?: string;
            job_title?: string;
            /** Format: uuid */
            country_id?: string;
            city?: string;
            company_name?: string;
            phone_number?: string;
            /** Format: uuid */
            industry_id?: string;
          };
        };
      };
    };
  };
  /** This endpoint returns algolia credentials and common indices for the specified conference. */
  getAlgoliaSettings: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["AlgoliaSettings"];
          };
        };
      };
    };
  };
  /** This endpoint returns details about an appearance. */
  getAppearance: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        id: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Appearance"];
          };
        };
      };
    };
  };
  /** Uploads and updates the avatar of the currently authenticated attendee. */
  uploadAvatar: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** Created */
      201: {
        content: {
          "application/json": {
            data: components["schemas"]["UploadedAvatar"];
          };
        };
      };
    };
    requestBody: {
      content: {
        "multipart/form-data": {
          /** Format: binary */
          avatar: string;
        };
      };
    };
  };
  /**
   * Starts the phone number verification flow for the authenticated attendee. A verification code will be sent to the provided phone number, and should be submitted to the `verify_pin_code` endpoint to complete the verification.
   *
   * If we were unable to send a verification code to the provided phone number the response will be 422.
   */
  startPhonerNumberVerification: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: unknown;
      /** Unprocessable Entity (WebDAV) */
      422: unknown;
    };
    requestBody: {
      content: {
        "application/json": {
          phone_number: string;
        };
      };
    };
  };
  /**
   * Completes phone number verification by confirming the verification code received in the `verify_phone_number` endpoint.
   *
   * If verification fails the response will be 404.
   */
  completePhoneNumberVerification: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            status: number;
            body: string;
          };
        };
      };
      /** Not Found */
      404: unknown;
    };
    requestBody: {
      content: {
        "application/json": {
          verification_code: string;
        };
      };
    };
  };
  /** This endpoint returns a list of all public timeslots on the schedule. When authenticated as admin, non-public timeslots are also returned. */
  listTimeslots: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
      query: {
        /** Return results for the specified schedule track */
        schedule_track_id?: string;
        /** Return results for the specified location */
        location_id?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Timeslot"][];
          };
        };
      };
    };
  };
  /** This endpoint returns a list of all public timeslots on the schedule that are currently ongoing. When authenticated as admin, non-public timeslots are also returned. */
  liveNow: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
      query: {
        /** Return results for the specified schedule track */
        schedule_track_id?: string;
        /** Return results for the specified location */
        location_id?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["TimeslotV2"][];
          };
        };
      };
    };
  };
  /**
   * This endpoint creates a new OTP challenge for the one-time code login flow. On success the server responds with a nonce and sends a one-time code to the attendee's email address. The client may verify an OTP challenge using the nonce + code.
   *
   * A challenge may only be verified once and expires after a short time.
   */
  createOtpChallenge: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** Created */
      201: {
        content: {
          "application/json": {
            data: components["schemas"]["OtpChallenge"];
          };
        };
      };
    };
    requestBody: {
      content: {
        "application/json": {
          /** @description Either an email address or ticket reference belonging to an active attendee. */
          login: string;
          /**
           * @description The app that will verify the challenge.
           * @default mobile
           * @enum {string}
           */
          app?: "mobile" | "webapp";
        };
      };
    };
  };
  /**
   * This endpoint verifies a challenge issued by the createOtpChallenge endpoint. On success a JWT token is returned that can be used to authenticate as an attendee.
   *
   * This endpoint is rate limited after a certain number of failed attempts.
   */
  verifyOtpChallenge: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        /** Nonce of the challenge to verify */
        id: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["OtpChallengeResponse"];
          };
        };
      };
      401: components["responses"]["Error"];
    };
    requestBody: {
      content: {
        "application/json": {
          code: string;
        };
      };
    };
  };
  /** Creates and returns credentials required to connect to chat. When called on mobile the device will be recorded as an active device for the attendee. */
  configureChat: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["ChatSettings"];
          };
        };
      };
    };
    requestBody: {
      content: {
        "application/json": {
          /** @enum {string} */
          provider: "pubnub";
        };
      };
    };
  };
  /** This endpoint retrieves a single attendee by ID. */
  getAttendee: {
    parameters: {
      path: {
        /** Unique human-friendly conference specifier */
        slug: components["parameters"]["Slug"];
        /** Attendee ID */
        id: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          "application/json": {
            data: components["schemas"]["Attendee"];
          };
        };
      };
      404: components["responses"]["Error"];
    };
  };
}

export interface external {}

export enum ApiPaths {
  listResponseStatuses = "/response_statuses",
  getLeadStats = "/conferences/:slug/appearances/:appearanceId/leads/stats",
  updateLead = "/conferences/:slug/appearances/:appearanceId/leads/:leadId",
  exportLeads = "/conferences/:slug/appearances/:appearanceId/leads/export",
  listLeads = "/conferences/:slug/appearances/:appearanceId/leads",
  getConference = "/conferences/:slug",
  listConferences = "/conferences",
  getInvestorMeetingInfo = "/conferences/:slug/investor_meetings",
  submitInvestorMeeting = "/conferences/:slug/investor_meetings/submit",
  selectInvestorMeetingSession = "/conferences/:slug/investor_meetings/session",
  addInvestorMeetingSelection = "/conferences/:slug/investor_meetings/selections",
  removeInvestorMeetingSelection = "/conferences/:slug/investor_meetings/selections",
  getStartupMeetingInfo = "/conferences/:slug/startup_meetings",
  acceptStartupMeetingSession = "/conferences/:slug/startup_meetings/:sessionId/accept",
  rejectStartupMeetingSession = "/conferences/:slug/startup_meetings/:sessionId/reject",
  introduceStartupMeetingSession = "/conferences/:slug/startup_meetings/:sessionId/introduce",
  acceptStartupMeetingGdpr = "/conferences/:slug/startup_meetings/gdpr",
  listCountries = "/conferences/:slug/countries",
  listTopics = "/conferences/:slug/conference_topics",
  listIndustries = "/conferences/:slug/conference_industries",
  getVisaLetterRequest = "/conferences/:slug/me/visa_letter_requests",
  requestVisaLetter = "/conferences/:slug/me/visa_letter_requests",
  getRegistrationCertificateLetterRequest = "/conferences/:slug/me/registration_certificate_letters",
  requestRegistrationCertificateLetter = "/conferences/:slug/me/registration_certificate_letters",
  getUser = "/conferences/:slug/me",
  updateProfile = "/conferences/:slug/me",
  getAlgoliaSettings = "/conferences/:slug/algolia",
  getAppearance = "/conferences/:slug/appearances/:id",
  uploadAvatar = "/conferences/:slug/me/avatar",
  startPhonerNumberVerification = "/conferences/:slug/me/people/verify_phone_number",
  completePhoneNumberVerification = "/conferences/:slug/me/people/verify_pin_code",
  listTimeslots = "/conferences/:slug/schedule_timeslots",
  liveNow = "/conferences/:slug/schedule_timeslots/live_now",
  createOtpChallenge = "/conferences/:slug/otp_challenges",
  verifyOtpChallenge = "/conferences/:slug/otp_challenges/:id/verify",
  configureChat = "/conferences/:slug/me/chat_token",
  getAttendee = "/conferences/:slug/attendances/:id",
}
